import script from "./MemberDetailBankbookTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberDetailBankbookTest.vue?vue&type=script&setup=true&lang=ts"

import "./MemberDetailBankbookTest.vue?vue&type=style&index=0&id=5840d279&lang=scss"

const __exports__ = script;

export default __exports__